<template>
  <div>
    <v-container fluid class="d-flex pa-0 fullHeight">
      <v-container fluid class="scrollableContent pa-0">
        <v-container class="container-custom px-6">
          <Breadcrumbs
            :description="breadcrumbs.description"
            :title="breadcrumbs.title"
          >
            <Button
              @clicked="newTitle"
              :icon="'mdi-plus'"
              :text="$t('actions.new')"
              depressed
            ></Button>
          </Breadcrumbs>
          <v-row justify="center">
            <v-col sm="12" class="viewSpaces">
              <SuperTable
                :headers="headers"
                :users="allStudentTitles"
                :clear-selected="clearSelected"
                :deleteTitle="$t('modules.departments.table.bulk_delete')"
                :loading="createButton.loading"
                @updateTitle="
                  (id) => {
                    editTitle(id);
                  }
                "
                @generateStudentTitle="
                  (id) => {
                    generateStudentTitlePdf(id);
                  }
                "
                @downloadTitleStamped="
                  (id) => {
                    downloadTitleStamp(id);
                  }
                "
                @downloadTitleNotStamped="
                  (id) => {
                    downloadTitleNotStamp(id);
                  }
                "
                @cancelTitle="
                
                  (titleId) => {
                    cancelStudentTitle(titleId);
                  }
                "
                @restoreTitle="
                
                (titleId) => {
                  restoreTitle(titleId);
                }
                "
                :permissions="{ update: canUpdate, delete: canDelete }"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-container>
    </v-container>
  </div>
</template>
 
<script>
import Constants from '../../../../../core/plugins/constants';
import SuperTable from '../Components/SuperTable.vue';
import Button from '@/components/Button/Button';
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs';
import { $student } from '../Services';
import download from 'downloadjs';
export default {
  components: {
    SuperTable,
    Breadcrumbs,
    Button,
  },
  data() {
    return {
      breadcrumbs: {
        title: 'Títulos',
        description: 'Administración de títulos.',
        button: {
          name: 'Nuevo',
          icon: 'mdi-plus',
          color: 'primary',
        },
      },
      headers: [
        {
          text: 'Número',
          value: 'id',
        },
        {
          text: 'Legajo',
          value: 'studentRecordId',
        },
        {
          text: 'Alumno',
          value: 'studentName',
        },
        {
          text: 'Título',
          value: 'academicDegree.degreeDescription',
        },
        {
          text: 'Nota final',
          value: 'grade'
        },
        {
          text: 'Fecha último estado',
          value: 'statusDate',
        },
        {
          text: 'Libre de deuda',
          value: 'hasNoDebt'
        },
        {
          text: 'Estado de título',
          value: 'status',
        },
        {
          text: '',
          value: 'action',
        },
      ],
      allStudentTitles: [],
      titleStampUrl: '',
      titleNotStamp: '',
      clearSelected: '',
      createButton: {
        loading: false,
        success: false,
        error: false,
      },
    };
  },
  computed: {
    canRead() {
      return this.$permissions.portaladministrativo.academic.departments.READ;
    },
    canCreate() {
      return this.$permissions.portaladministrativo.academic.departments.CREATE;
    },
    canUpdate() {
      return (
        this.$permissions.portaladministrativo.academic.departments.READ ||
        this.$permissions.portaladministrativo.academic.departments.UPDATE
      );
    },
    canDelete() {
      return this.$permissions.portaladministrativo.academic.departments.DELETE;
    },
  },
  methods: {
    getAllStudentTitles() {
      $student
        .getAllStudentTitles()
        .then((studentData) => {
          this.allStudentTitles = studentData.data.map((title) => {
            const date = new Date(title.statusDate);
            
            const formattedDate = `${date.getUTCDate()}/${
              date.getUTCMonth() +1
            }/${date.getUTCFullYear()}`;

            title.statusDate = formattedDate;

            return title;
          });
        })
        .catch(() => {
          this.$store.dispatch('commons/openPopUp', {
              title: 'Error al obtener los títulos',
              actionPrimary: {
                text: 'Aceptar',
                callback() {},
              },
              icon: { color: 'error', name: 'mdi-alert' },
              color: 'primary',
            });
        });
    },
    newTitle() {
      if (this.canCreate) this.$router.push('titles/create');
    },
    editTitle(id) {
      if (this.canUpdate) this.$router.push(`titles/update/${id}`);
    },
    async generateStudentTitlePdf(id) {
      if (this.canRead) {
        await $student
          .generateStudentTitle(id)
          .then(() => {
            this.getAllStudentTitles();
            this.$store.dispatch('commons/openPopUp', {
              title: 'Título generado con éxito',
              actionPrimary: {
                text: 'Aceptar',
                callback() {},
              },
              actionSecondary: {
                text: 'Descargar',
                callback: () => {
                  this.downloadTitleStamp(id);
                },
              },
              icon: { color: 'success', name: 'mdi-check' },
              color: 'primary',
            });
          })
          .catch(() => {
            this.$store.dispatch('commons/openPopUp', {
              title: 'Título generado con éxito',
              actionPrimary: {
                text: 'Aceptar',
                callback() {},
              },
              icon: { color: 'error', name: 'mdi-alert' },
              color: 'primary',
            });
          });
      }
    },
    downloadTitleStamp(id) {
      if (this.canRead) {
        $student
          .downloadTitle(id)
          .then((titleStamp) => {
            const titleStampUrl = titleStamp.data;

            window.open(titleStampUrl, '_blank');

          })
          .catch(() => {
            this.$store.dispatch('commons/openPopUp', {
              title: 'Error al obtener el título del estudiante',
              actionPrimary: {
                text: 'Aceptar',
                callback() {},
              },
              icon: { color: 'error', name: 'mdi-alert' },
              color: 'primary',
            });
          });
      }
    },
    async downloadTitleNotStamp(id) {
      if (this.canRead) {
        const options = Constants.getFetchOptions(
          null,
          Constants.HTTP_METHOD_GET
        );
        const response = await fetch(
          `${Constants.URL_STUDENT_SERVER}/student/title/${id}/generate/simulate`,
          options
        );
        const blob = await response.blob();
        this.downloadBlobAsFile(blob, 'title.pdf');
        const content = response.headers['content-type'];
        download(response.data, `title.pdf`, content);
        this.createButton.loading = false;
      } else {
        this.$store.dispatch('commons/openPopUp', {
          title: 'Error al obtener el título del estudiante',
          actionPrimary: {
            text: 'Aceptar',
            callback() {},
          },
          icon: { color: 'error', name: 'mdi-alert' },
          color: 'primary',
        });
      }
    },
    downloadBlobAsFile(blob, filename) {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },
  async cancelStudentTitle(titleId) {
  const titlesResponse = await $student.getTitlesByStTitleId(titleId);

  const updateStatus = {
    ...titlesResponse.data, 
    status: 4, 
  };

  try {
    await $student.updateStudentTitle(updateStatus);
    this.getAllStudentTitles();
    this.$store.dispatch('commons/openPopUp', {
      title: 'Título anulado con éxito',
      actionPrimary: {
        text: 'Aceptar',
        callback() {},
      },
      icon: { color: 'success', name: 'mdi-check' },
      color: 'primary',
    });
  } catch {
    this.$store.dispatch('commons/openPopUp', {
      title: 'Error al anular el título del estudiante',
      actionPrimary: {
        text: 'Aceptar',
        callback() {},
      },
      icon: { color: 'error', name: 'mdi-alert' },
      color: 'primary',
    });
  }
  },
    async restoreTitle(titleId) {
      const titlesResponse = await $student.getTitlesByStTitleId(titleId);

      const updateStatus = {
        ...titlesResponse.data, 
        status: 1 
      };

      try {
        await $student.updateStudentTitle(updateStatus);
        this.getAllStudentTitles();
        this.$store.dispatch('commons/openPopUp', {
          title: 'Título actualizado con éxito',
          actionPrimary: {
            text: 'Aceptar',
            callback() {},
          },
          icon: { color: 'success', name: 'mdi-check' },
          color: 'primary',
        });
      } catch {
        this.$store.dispatch('commons/openPopUp', {
          title: 'Error al restaurar el título del estudiante',
          actionPrimary: {
            text: 'Aceptar',
            callback() {},
          },
          icon: { color: 'error', name: 'mdi-alert' },
          color: 'primary',
        });
      }
    },
  },
  mounted() {
    this.getAllStudentTitles();
  }
};
</script>